import { EventName } from '../types';

const enabledProductionEvents: string[] = [
  EventName.FilterApplied,
  EventName.PageViewed,
  EventName.FilterAppliedDetails,
  EventName.PageElementViewed,
  EventName.ChartInteractions,
  EventName.PageElementClicked,
  EventName.TableClicked,
  EventName.DataExported,
  EventName.DataExportInitiated,
  EventName.NavigationClicked,
];

export const isTrackingEnabled = (eventName: string): boolean =>
  enabledProductionEvents.includes(eventName) || localStorage.getItem('m2_analytics_test') === 'on';
